class PhotosBattle {

  constructor() {

    if (!this.setVars())
      return

    this.setEvents()
  }

  setVars() {

    this.section = document.querySelector('.photosBattle')

    if (!this.section)
      return

    this.wrapper        = this.section.querySelector('.photosBattle__wrapper')
    this.items          = this.wrapper.querySelectorAll('.photosBattle__item')
    this.buttons        = this.wrapper.querySelectorAll('.photosBattle__percent')
    this.percentsValues = this.wrapper.querySelectorAll('.photosBattle__percentValue')
    this.count          = this.section.querySelector('.photosBattle__footerInfoCount')

    return true

  }

  setEvents() {

    this.items.each((item, index) => {

      item.addEventListener('click', (e) => {

        e.preventDefault()
        this.saveVote(index)

      })

    })

    this.buttons.each((item, index) => {

      item.addEventListener('click', (e) => {

        e.preventDefault()
        this.saveVote(index)

      })

    })

  }

  saveVote(index) {

    var id = $("#md_id").val();
    var that = this;
    var vote_num = index + 1;

    $.getJSON("/mastersDuelVote?id="+id+"&vote_num="+vote_num, function(data) {

    	that.wrapper.addClass('photosBattle__wrapper--active')
	    that.items[index].addClass('photosBattle__item--active')

	    that.buttons[0].setAttribute('data-percent', data.vote1)
	    that.buttons[1].setAttribute('data-percent', data.vote2)

	    that.percentsValues[0].innerHTML = data.vote1 + '%'
	    that.percentsValues[1].innerHTML = data.vote2 + '%'

        that.count.innerHTML = parseInt(that.count.innerHTML) + 1

        setCookie('md_' + id, '1', 1)
    });

  }

}
